import React from "react";
import ArrowDown from "./arrow-down";
import ArrowLeft from "./arrow-left";
import Chat from "./chat";
import ChevronDown from "./chevron-down";
import ChevronLeftShape from "./chevron-left-shape";
import ChevronRightShape from "./chevron-right-shape";
import ChevronRight from "./chevron-right";
import Close from "./close";
import Email from "./email";
import External from "./external";
import Facebook from "./facebook";
import File from "./file";
import Link from "./link";
import LinkedIn from "./linkedin";
import Minus from "./minus";
import Phone from "./phone";
import Play from "./play";
import Plus from "./plus";
import X from "./x";
import Youtube from "./youtube";
import Zip from "./zip";

interface IconProps {
  symbol: string;
}

const Icon: React.FC<IconProps> = ({ symbol }) => {
  if(!symbol) {
    return null;
  }
  
  switch (symbol) {
    case "arrow-down":
      return <ArrowDown />;
    case "arrow-left":
      return <ArrowLeft />;
    case "chat":
      return <Chat />;
    case "chevron-down":
      return <ChevronDown />;
    case "chevron-left-shape":
      return <ChevronLeftShape />;
    case "chevron-right-shape":
      return <ChevronRightShape />;
    case "chevron-right":
      return <ChevronRight />;
    case "close":
      return <Close />;
    case "email":
      return <Email />;
    case "external":
      return <External />;
    case "facebook":
      return <Facebook />;
    case "file":
      return <File />;
    case "link":
      return <Link />;
    case "linkedin":
      return <LinkedIn />;
    case "minus":
      return <Minus />;
    case "phone":
      return <Phone />;
    case "play":
      return <Play />;
    case "plus":
      return <Plus />;
    case "x":
      return <X />;
    case "youtube":
      return <Youtube />;
    case "zip":
      return <Zip />;
    default:
      return <span>Unknown icon: {symbol}</span>;
  }
}

export default Icon;
